<template>
  <!--教师项目申报提交页面-->
  <v-card class="main-content-card" flat id="personal-index-review">
    <v-toolbar flat>
      <v-toolbar-title>项目申报</v-toolbar-title>
      <span class="subheading ml-2">|</span>

    </v-toolbar>

    <v-divider/>

    <v-form ref="formRef">
      <v-container grid-list-md class="pt-0">
        <v-layout wrap>
          <v-flex xs3>
            <v-text-field
                label="申报名称"
                :rules="rules.required"
                v-model="form.name"
            />
          </v-flex>

          <v-flex sm3>
            <v-menu
                ref="refReviewStart"
                :close-on-content-click="false"
                v-model="menuReviewStart"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px">
              <v-text-field
                  slot="activator"
                  v-model="form.reviewStart"
                  label="申报日期(起始)"
                  :rules="rules.endDate"
                  hint="格式YYYY-MM-DD"
                  persistent-hint
              />
              <v-date-picker
                  v-model="reviewStart"
                  locale="zh-cn"
                  @change="nv => form.reviewStart= nv"
              />
            </v-menu>
          </v-flex>

          <v-flex sm3>
            <v-menu
                ref="refReviewEnd"
                :close-on-content-click="false"
                v-model="menuReviewEnd"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px">
              <v-text-field
                  slot="activator"
                  v-model="form.reviewEnd"
                  label="申报日期(截止)"
                  :rules="rules.endDate"
                  hint="格式YYYY-MM-DD"
                  persistent-hint
              />
              <v-date-picker
                  v-model="reviewEnd"
                  locale="zh-cn"
                  @change="nv => form.reviewEnd= nv"
              />
            </v-menu>
          </v-flex>

          <v-flex sm2>
            <v-autocomplete
                clearable
                v-model="form.reviewStatusId"
                item-text="name"
                item-value="dbid"
                :items="reviewStatusItems"
                label="状态"
            />
          </v-flex>

          <v-flex sm1 class="text-xs-right">
            <v-btn color="primary" @click.native="onSearch">检索</v-btn>
          </v-flex>

        </v-layout>
      </v-container>
    </v-form>

    <v-divider/>

    <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-0"
        :loading="isLoading"
        :pagination.sync="query"
        :rows-per-page-items="[25, 50, 100]"
        no-data-text="没有数据。">
      <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td>{{ props.index + 1 }}</td>
        <td class="">{{ props.item.name }}</td>
        <td class="">
          {{ props.item.ifPreReview }}
          <br/>
          {{ props.item.ifAnonymousLooseLeaf }}
        </td>
        <td class="">
          {{ props.item.startDate }}
          <br/>
          {{ props.item.finishDate }}
        </td>
        <td class="">{{ props.item.pubDate }}</td>
        <td class="">{{ props.item.operator }}</td>

        <td>
          <v-tooltip top>
            <v-chip small label class="mx-0" slot="activator"
                    :color="props.item.status.color"
                    @click="() => { history=props.item.history; hist = true; }">
              {{ props.item.status.name }}
            </v-chip>
            <span>点击查看审核历史</span>
          </v-tooltip>
        </td>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { viewDbid = props.item.dbid; viewBasic = true; }">
            <v-icon color="teal">more_horiz</v-icon>
          </v-btn>
          <span>查看</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click.native ="onPreReview(props.item)"
                 :disabled="prereviewDisabled(props.item)">
            <v-icon color="teal">email</v-icon>
          </v-btn>
          <span>提交初审</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click.native ="onSelect(props.item)"
                 :disabled="submitDisabled(props.item)">
            <v-icon color="teal">publish</v-icon>
          </v-btn>
          <span>提交申报</span>
        </v-tooltip>

      </template>
    </v-data-table>

    <!--此对话框用于处理不需要初审的项目提交-->
    <v-dialog
        scrollable
        v-model="projDeclare"
        max-width="900px"
        :persistent="true"
    >
      <v-card>
        <v-card-title class="subheading">
          选择项目提交申报（若无项目请先在我的项目页面点击项目申请登记项目信息）
        </v-card-title>
        <v-divider/>

        <v-card-text>
            <v-form v-model="formDecValid" ref="formDecRef" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm8>
                    <v-autocomplete
                        label="选择参与申报的项目"
                        required
                        :rules="rules.required"
                        @change="onSelectProj"
                        v-model="proj"
                        item-text="name"
                        item-value="dbid"
                        :items="projItems"
                        hint="只有我的项目页面下审核状态为未提交的项目会出现在此列表中！"
                        persistent-hint
                    />
                  </v-flex>

                  <v-flex xs12>
                    <x-uploader
                        v-if="!ifAnonymousLooseLeaf && projSelected"
                        label="上传匿名活页"
                        :action="fileUri"
                        v-model="AnonymousLooseLeaf"
                        @input="(it) => Object.assign(AnonymousLooseLeafItems,it)"
                        :size="Number(50)"
                        description="单个附件大小不超过 50M."
                    />
                  </v-flex>

                  <v-flex xs12>
                    <div v-if="!ifAnonymousLooseLeaf && projSelected">上传匿名活页文件请命名为"匿名活页.pdf"或"匿名活页.doc"</div>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
           <v-btn color="primary" @click.native= "projDeclare = false">
             <v-icon dark >cancel</v-icon>取消
           </v-btn>
           <v-btn color="primary" @click.native="onSubmit">
             <v-icon dark >mail</v-icon>提交申报
           </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!--此对话框用于处理需要初审的申报项目提交-->
    <v-dialog
        scrollable
        v-model="preReview"
        max-width="900px"
        :persistent="true"
    >
      <v-card>
        <v-card-title class="subheading">
          选择项目提交初审（若无项目请先在我的项目页面点击项目申请登记项目信息）
        </v-card-title>
        <v-divider/>

        <v-card-text>
          <v-form v-model="formPreValid" ref="formPreRef" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm8>
                  <v-autocomplete
                      label="选择参与申报初审的项目"
                      required
                      :rules="rules.required"
                      v-model="projPreReview"
                      @change="onSelectPreProj"
                      item-text="name"
                      item-value="dbid"
                      :items="projPreItems"
                      hint="只有我的项目页面下状态为未提交或初审驳回的项目会出现在此列表中！"
                      persistent-hint
                  />
                </v-flex>


                <v-flex xs12>
                  <x-uploader
                      v-if="!preIfAnonymousLooseLeaf && projPreSelected"
                      label="上传匿名活页"
                      :action="preFileUri"
                      v-model="preAnonymousLooseLeaf"
                      :size="Number(50)"
                      description="单个附件大小不超过 50M."
                  />
                </v-flex>

                <v-flex xs12>
                  <div v-if="!preIfAnonymousLooseLeaf && projPreSelected">上传匿名活页文件请命名为"匿名活页.pdf"或"匿名活页.doc"</div>
                </v-flex>

              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click.native= "preReview = false">
            <v-icon dark >cancel</v-icon>取消
          </v-btn>
          <v-btn color="primary" @click.native="onSubmitPreReview">
            <v-icon dark >mail</v-icon>提交初审
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <x-history
        v-model="hist"
        :history="history"
        :status="statusItems"
    />

    <x-view-review
        v-model="viewBasic"
        :dbid="viewDbid"
    />


  </v-card>
</template>

<script>

import XHistory from "@/components/global/History";
import XUploader from '@/components/global/Uploader'
import XViewReview from '@/components/proj/review/ViewReview'
const baseURI = '/api/proj/review';
const reviewStatusUri = '/api/proj/review-status';
const statusUri = '/api/proj/status';
const baseProUri = '/api/proj/project';
const attachURI = '/api/proj/attachment';
export default {
  name: "PersonalReview",
  components: {XHistory, XUploader, XViewReview},
  data: () => ({
    form: {
      name: '',
      reviewStart: '',
      reviewEnd: '',
      reviewStatusId: ''
    },

    formDecValid: false,
    formPreValid: false,

    query: {
      page: 1,
      rowsPerPage: 25,
      sortBy: 'rkrq',
      descending: true,
      totalItems: null
    },

    curReviewId: '',

    items: [],
    isLoading: false,

    reviewStart: '',
    menuReviewStart: false,

    reviewEnd: '',
    menuReviewEnd: false,

    reviewStatusItems : [],
    statusItems: [],

    //正常申报是否需要活页
    ifAnonymousLooseLeaf: false,
    //正常申报上传活页组件
    AnonymousLooseLeaf: [],
    //初审申报是否需要活页
    preIfAnonymousLooseLeaf: false,
    //初审申报上传活页组件
    preAnonymousLooseLeaf: [],


    proj: {},
    projPreReview : {},

    AnonymousLooseLeafItems:[],

    projItems: [],
    projPreItems: [],
    declareItems : [],

    hist: false,
    history: [],

    projDeclare: false,

    //判断是否选择了准备提交的项目，控制附件上传组件的可视
    projSelected: false,
    projPreSelected: false,

    viewBasic: false,
    viewDbid: null,

    fileUri: '',
    preFileUri: '',

    headers: [
      {
        text: '#',
        sortable: false,
        value: 'dbid',
        width: '20'
      },
      // {text: '#', sortable: false, value: 'rank', width: 18},
      {text: '申报名称', sortable: false, value: 'name', align: 'left'},
      {text: '初审 / 匿名活页', sortable: false, value: 'ifPreReview', width: 150, align: 'left'},
      {text: '开始日期 / 截止日期', sortable: false, value: 'startDate', width: 150, align: 'left'},
      {text: '发布日期', value: 'pubDate', sortable: false, align: 'left', width: 200},
      {text: '发布人', value: 'operator', sortable: false, align: 'center', width: 120},
      {text: '操作', align: 'center', sortable: false, value: 'dbid', width: "60"}
    ],

    preReview: false,

    /**
     * 验证规则
     */
    rules: {
      required: [
        v => !!v || '必填项。',
      ],
    }

  }),

  methods: {
    onSelect(item) {
      this.curReviewId = item.dbid
      this.projDeclare = true
      if (item.ifAnonymousLooseLeaf === "否") {
        this.ifAnonymousLooseLeaf = true
      }
      else
      {
        this.ifAnonymousLooseLeaf = false
      }
    },

    onPreReview(item) {
      this.curReviewId = item.dbid
      this.preReview = true
      if (item.ifAnonymousLooseLeaf === "否") {
        this.preIfAnonymousLooseLeaf = true
      }
      else
      {
        this.preIfAnonymousLooseLeaf = false
      }
      window.console.log("this.preIfAnonymousLooseLeaf")
      window.console.log(this.preIfAnonymousLooseLeaf)
    },

    onSearch() {
      Object.assign(this.query, this.form);
      this.query.page = 1;
      this.isLoading = true;
      this.axios.get(baseURI, {params: window.xutil.toApiQuery(this.query)})
          .then(
              rsp => {
                this.isLoading = false;
                this.items = rsp.data.items;
              })
          .finally(() => this.isLoading = false);
    },

    //不需要初审的申报项目提交处理
    onSubmit() {
      const vm = this;
      //通过判断项目选择组件的ID长度判断待提交项目是否选择
      if (vm.proj.length === 11) {
        //如果申报需要活页，则判断是否上传活页
        if (!vm.ifAnonymousLooseLeaf) {
          if (this.AnonymousLooseLeaf.length > 0) {
            //已上传活页
            let declare = {
              reviewId: vm.curReviewId,
              projId: vm.proj,
              preReview: "false"
            }
            this.axios.post(`${baseURI}/${vm.curReviewId}/${vm.proj}`, declare)
                .then(rsp => {
                  vm.declareItems = rsp.data
                  this.projItems.splice(this.projItems.findIndex(item => item.dbid === this.proj))
                  alert("项目申报已提交！")
                  this.AnonymousLooseLeaf = []
                  vm.projSelected = false
                  vm.projDeclare = false
                });
          }
          else
          {
            alert("本申报需要上传匿名活页！")
          }
        }
        //申报不需要活页，直接进入申报处理
        else
        {
          window.console.log("进入申报处理！")
          let declare = {
            reviewId: vm.curReviewId,
            projId: vm.proj,
            preReview: "false"
          }
          this.axios.post(`${baseURI}/${vm.curReviewId}/${vm.proj}`, declare)
          .then(rsp => {
            vm.declareItems = rsp.data
            this.projItems.splice(this.projItems.findIndex(item => item.dbid === this.proj))
            alert("项目申报已提交！")
            vm.projDeclare = false
          });
        }
      }
      else
      {
        alert("请选择待提交申报的项目！")
      }
    },

    //需要初审的申报项目提交处理
    onSubmitPreReview() {
      const vm = this;
      if (vm.projPreReview.length === 11)
      {
        //如果申报需要活页，则判断是否上传活页
         if (!vm.preIfAnonymousLooseLeaf)
         {
           if (this.preAnonymousLooseLeaf.length > 0) {
             //已上传活页
             let declare = {
               reviewId: vm.curReviewId,
               projId: vm.projPreReview,
               preReview: "true"
             }

             window.console.log("projId")
             window.console.log(declare.projId)
             this.axios.post(`${baseURI}/${vm.curReviewId}/${vm.projPreReview}`, declare)
                 .then(rsp => {
                   vm.declareItems = rsp.data
                   this.projPreItems.splice(this.projPreItems.findIndex(item => item.dbid === declare.projId))
                   alert("项目申报初审已提交！")
                   this.preAnonymousLooseLeaf = []
                   vm.projPreSelected = false
                   vm.preReview = false
                 });
           }
           else
           {
             alert("本申报需要上传匿名活页！")
           }
         }
         //申报不需要活页，直接进入申报处理
         else
         {
           let declare = {
             reviewId: vm.curReviewId,
             projId: vm.projPreReview,
             preReview: "true"
           }
           window.console.log("projId")
           window.console.log(declare.projId)
           this.axios.post(`${baseURI}/${vm.curReviewId}/${vm.projPreReview}`, declare)
               .then(rsp => {
                 vm.declareItems = rsp.data
                 this.projPreItems.splice(this.projPreItems.findIndex(item => item.dbid === declare.projId))
                 alert("项目申报初审已提交！")
                 vm.preReview = false
                 vm.projPreSelected = false
               });
         }
      }
      else
      {
        alert("请选择待提交申报初审的项目！")
      }
    },

    //申报列表提交申报按钮是否禁用处理
    submitDisabled(item) {
      //只有申报不需要初审且申报状态为接收，教师才可以提交项目至申报
      return !((item.ifPreReview === "否") && (item.statusId === 'recieve'))
    },

    //申报列表提交初审按钮是否禁用处理
    prereviewDisabled(item) {
      //只有申报需要初审且申报状态为接收，教师才可以提交项目至初审
      return !((item.ifPreReview === "是") && (item.statusId === 'recieve'))
    },

    onSelectPreProj() {
      if (this.projPreReview) {
        this.preFileUri = `${attachURI}?ownerId=${this.projPreReview}`;
        this.axios
            .get(`${attachURI}?projectId=${this.projPreReview}`)
            .then(rsp => this.preAnonymousLooseLeaf = rsp.data.items)
        this.projPreSelected = true
      }
    },

    onSelectProj() {
      if (this.proj) {
        this.fileUri = `${attachURI}?ownerId=${this.proj}`;
        this.projSelected = true
      }
    },

  },

  mounted() {
        Object.assign(this.query, this.form);
        this.query.page = 1;
        this.isLoading = true;
        this.axios.get(baseURI, {params: window.xutil.toApiQuery(this.query)})
            .then(
                rsp => {
                  this.isLoading = false;
                  this.items = rsp.data.items;
                  this.items = this.items.filter(item => item.statusId != 'unpub')
                })
            .finally(() => this.isLoading = false);
  },

  created() {
    let t = 'review'
    this.axios.all([
      this.axios.get(reviewStatusUri, {params: {sort: 'rank.asc'}}),
      this.axios.get(`${statusUri}/${t}`, {params: {sort: 'rank.asc'}}),
      this.axios.get(`${baseProUri}/by/request/user`)])
        .then(
            this.axios.spread(
                (rspReviewStatus,rspStatus,rspPro) => {
                  this.isLoading = false;
                  this.statusItems = rspStatus.data;
                  this.reviewStatusItems = rspReviewStatus.data.items;
                  this.projItems = rspPro.data.items;
                  this.projPreItems = rspPro.data.items;
                  this.projItems = this.projItems.filter(item => item.statusId === 'draft')
                  this.projPreItems = this.projPreItems.filter(item => item.statusId === 'draft' || item.statusId === 'pre_returned')
                })
        )
  }


}
</script>

<style scoped>

</style>